module.exports = __webpack_public_path__ + "static/media/siddharth-palamaner-trip-01.fad45eb1.png";